import 'youtube-background';
import {Fancybox} from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";
import {initModal} from '../../resources/js/module/modal';

$(document).ready(function () {
  initModal();
  Fancybox.bind("[data-fancybox]", {
    // Your options go here
  });
})

const textContent = document.querySelectorAll('.modal .text')
const tipsItems = document.querySelectorAll('.tips-item')
const modals = document.querySelectorAll('.modal')

Array.from(textContent).forEach(item => {
  if (item.scrollHeight <= item.clientHeight) {
    item.closest('.text-wrapper').classList.add('non-scrolling')
    return
  }

  item.addEventListener('scroll', (e) => {
    const {scrollTop, scrollHeight, clientHeight} = e.target
    const progressBar = document.getElementById('progressBar')
    const progressBarWidth = progressBar.clientWidth
    const scrollPercentage = ((scrollTop / (scrollHeight - clientHeight + progressBarWidth)) * 100)

    progressBar.style.top = scrollPercentage + '%'
  })
})

Array.from(modals).forEach(item => {
  item.addEventListener('click', (e) => {
    if (!e.target.closest('.modal-window') || e.target.closest('.close')) {
      e.currentTarget.classList.remove('visible')
      document.body.style.overflow = ''
    }
  })
})

Array.from(tipsItems).forEach(item => {
  item.addEventListener('click', (e) => {
    e.currentTarget.nextElementSibling.classList.add('visible')
    document.body.style.overflow = 'hidden'
  })
})
